import { FlexRow, IconContainer, Panel, Text } from '@epam/promo';
import css from './BroadcastProgress.module.scss';
import { Icon } from '@epam/uui-core';

interface TimestampRowProps {
  title: string;
  value: string | number;
  Icon: Icon;
}

const TimestampRow = ({ title, value, Icon }: TimestampRowProps) => {
  return (
    <FlexRow cx={css.progress__timestamp}>
      <IconContainer
        icon={Icon}
        size="18"
        style={{ fill: 'var(--uui-neutral-60)', alignSelf: 'start' }}
      />

      <Panel>
        <Text color="gray60" fontSize="14" size="none">{`${title}:`}</Text>
        <Text fontSize="16" fontWeight="600" size="none">
          {value}
        </Text>
      </Panel>
    </FlexRow>
  );
};

export default TimestampRow;
